import React from "react";
import { onSnapshot, getSnapshot } from "mobx-state-tree";
import Cookies from "universal-cookie";
import Parser from "url-parse";

import Router from "./routes/Router.js";
import Order from "./models/Order";
import {
  clearParentToChildCookieData,
  clearMaleToFemaleCookieData
} from "./models/Book";
import { productTypeMap } from "./utils";

import "./App.less";

const cookies = new Cookies();

let url = Parser(window.location.href, true),
  n = url.query.new !== undefined,
  key = url.query.key, // keyパラメータを取得
  o = JSON.parse(localStorage.getItem('store')) || cookies.get("order") || {};
let order = null;

console.log(window.location.href);
console.log(window.location.search);
console.log(new URLSearchParams(window.location.search).get('key'));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: !!key, // keyがある場合はローディング状態
      error: false,
      errorMessage: ''
    };

    const productType = productTypeMap[props.productType];

    // keyパラメータがない場合、bridalデータを空にリセット
    if (!key && o.book && o.book.bridal) {
      o.book.bridal = {
        key: "",
        venueCode: "",
        weddingDate: "",
        style: "",
        customerName: "",
        brideColor: "",
        groomColor: "",
        isVideo: ""
      };
    }

    // keyパラメータがある場合はAPIリクエスト
    if (key) {
      this.fetchSaveData(key, n, productType, props);
    } else {
      // keyがない場合は通常の初期化処理
      this.initializeOrder(n, productType, o, props);
    }
  }

  async fetchSaveData(key, n, productType, props) {
    /* const currentDomain = window.location.hostname;

    console.log('Current domain:', currentDomain);
    console.log('Domain check - includes dev:', currentDomain.includes('dev')); */

    const baseApiUrl = process.env.REACT_APP_BRIDAL_API_ADDR || 'https://bridal-api.shikaketegami.com';
    const apiUrl = `${baseApiUrl}/savedata`;

    /* const apiUrl = currentDomain.includes('dev')
      ? 'https://dev-bridal-api.shikaketegami.com/savedata'
      : 'https://bridal-api.shikaketegami.com/savedata'; */

    const fullApiUrl = `${apiUrl}?key=${encodeURIComponent(key)}`;

    console.log('Selected API URL:', fullApiUrl);
    console.log('Environment:', process.env.NODE_ENV);

    try {
      const response = await fetch(fullApiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors'
      });

      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`API request failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log('Received data:', data);

      // データが空やnullの場合はエラー
      if (!data || Object.keys(data).length === 0) {
        console.error('Empty data received');
        throw new Error('データが見つかりませんでした');
      }
      // URLパラメータのkeyをデータに追加
      const bridalDataWithKey = {
        ...data,
        key: key
      };

      // 取得したデータでorderを初期化
      this.initializeOrder(n, productType, o, props, bridalDataWithKey);
      this.setState({ loading: false, error: false });
    } catch (error) {
      console.error('Error fetching save data:', error);
      this.setState({
        loading: false,
        error: true,
        errorMessage: error.message
      });
    }
  }

  initializeOrder(n, productType, o, props, bridalData = null) {
    // 新規作成かどうか
    if (n) {
      // TODO: ここの判定は今後商品が増えると変更が必要かも
      if (productType === "parent_to_child") {
        o.currentStepParentToChild = "info";
        o.stepParentToChild = 0;
        o.facesSavedParentToChild = false;
        o.storiesSavedParentToChild = false;

        if (o.book != null) {
          o.book.parentToChild = clearParentToChildCookieData(o.book.parentToChild)
        }
      } else if (productType === "child_to_parent") {
        o.currentStepChildToParent = "info";
        o.stepChildToParent = 0;
        o.facesSavedChildToParent = false;
        o.storiesSavedChildToParent = false;

        if (o.book != null) {
          o.book.childToParent = clearParentToChildCookieData(o.book.childToParent)
        }
      } else {
        // 男性から女性に贈るのセーブデータの初期化
        o.currentStep = "info";
        o.step = 0;
        o.facesSaved = false;
        o.storiesSaved = false;
        // 女性から男性に贈るのセーブデータの初期化
        o.currentStepFemaleToMale = "info";
        o.stepFemaleToMale = 0;
        o.facesSavedFemaleToMale = false;
        o.storiesSavedFemaleToMale = false;
        // 共通でcookieの値を初期化
        o.book = clearMaleToFemaleCookieData(o.book);
      }
    }

    order = Order.create(o);

    // onSnapshotを先に登録
    onSnapshot(order, (snapshot) => {
      const dataToSave = JSON.parse(JSON.stringify(snapshot));

      if (dataToSave.book &&
        dataToSave.book.bridal &&
        (!dataToSave.book.bridal.key || dataToSave.book.bridal.key.trim() === "")) {
        delete dataToSave.book.bridal;
      }

      localStorage.setItem('store', JSON.stringify(dataToSave)); // ← dataToSave に
    });

    // onSnapshot登録後にbridalDataを設定（keyが入った状態でsnapshotが走る）
    if (bridalData) {
      console.log('Setting bridal data:', bridalData);
      try {
        order.book.bridal.updateFromApi(bridalData);
      } catch (error) {
        console.error('Failed to update bridal data:', error);
      }
    }

    // 新規作成なら
    if (n) {
      localStorage.setItem('store', JSON.stringify(getSnapshot(order)));
    }

    order.book.changeArtistName(props.artistName);
    order.book.changeProductType(props.productType || 'male_to_female'); // デフォルト
    order.book.changeIsOrderedDigital(props.isOrderedDigital);
  }

  render() {
    const { loading, error, errorMessage } = this.state;

    if (loading) {
      return <div className="app">読み込み中...</div>;
    }

    if (error) {
      return (
        <div>
          <p>エラー</p>
        </div>
      );
    }

    return (
      <div className="app">
        <Router order={order} {...this.props} />
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js